module.exports = __webpack_public_path__ + "img/Specifications-Img-Vacuum-40-min-1.0591186c.2104beb2.png";